import Navbar from "./Navbar";
import "./HomePage.css";

export default function HomePage() {
    return (
        <div className="home-container">
            <Navbar />
            <div className="content">
                <h1>The Wild West World Bunch</h1>
                <p>
                    Step into The Wild West World Bunch—a thrilling adventure by Bug Busters that fuses the retro charm of the ZX Spectrum classic "The Wild Bunch" with the gritty allure of West World.
                    Prepare for a digital showdown where old-school pixel magic meets modern narrative depth, all in one wild, wild ride.
                </p>
                <img src="/images/splash.png" alt="Game Splash" className="splash-image" />
            </div>
        </div>
    );
}

